// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".image-wrapper[data-v-40073c6d]{display:block;height:100%;overflow:hidden;position:relative;width:100%}.primary-photo[data-v-40073c6d]{left:0;position:absolute;width:100%}@media screen and (min-width:320px) and (max-width:998px) and (orientation:landscape){.image-wrapper[data-v-40073c6d]{aspect-ratio:4/3;height:auto;width:100%}}.image-wrapper.desktop[data-v-40073c6d]{aspect-ratio:4/3;border-radius:0;height:auto;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
